import { isNil } from 'es-toolkit';

import { isPresent, toFiniteNumber } from '../common/utils';
import { ACCOUNT_SLEEVE_DIRECT_INDEXING_STRATEGY } from './constants';

export type AccountSleeveInput = {
  readonly id: string;
  readonly customName?: string | null;
  readonly directIndexing: boolean;
  readonly displayBalance: { readonly amount: string };
  readonly displayName: string;
  readonly strategyName?: string | null;
};

export type AccountSleeveLine = {
  readonly id: string;
  readonly title: string;
  readonly detail: string | null;
  readonly balance: number | null;
};

export function sleeveStrategyLabel(sleeve: AccountSleeveInput) {
  if (isPresent(sleeve.strategyName)) {
    return sleeve.strategyName;
  }
  if (isPresent(sleeve.customName)) {
    return sleeve.customName;
  }
  return sleeve.directIndexing ? ACCOUNT_SLEEVE_DIRECT_INDEXING_STRATEGY : null;
}

export function accountSleeveLines(
  sleeves: readonly AccountSleeveInput[] | null | undefined,
): readonly AccountSleeveLine[] {
  if (isNil(sleeves)) {
    return [];
  }
  return sleeves.map((sleeve) => {
    const strategy = sleeveStrategyLabel(sleeve);
    return {
      id: sleeve.id,
      title: strategy ?? sleeve.displayName,
      detail: isNil(strategy) ? null : sleeve.displayName,
      balance: toFiniteNumber(sleeve.displayBalance.amount),
    };
  });
}
